import { getCareArticles } from 'api/careArticles'
import LinkToActionPostModal from 'components/modals/lms/LinkToActionPostModal'
import { UIEntityItemConnection } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { isDefined } from 'utils'

export function QueryRangeCareArticle({
  value,
  onChange,
  disabled = false,
}: {
  value?: number | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...event: any[]) => void
  disabled?: boolean
}) {
  const careArticleByIdQuery = useQuery(
    ['getCareArticleById', value],
    () => {
      let filter = {}
      if (isDefined(value)) {
        filter = {
          id: {
            type: 'number',
            op: 'equals',
            value,
          },
        }
      }

      return getCareArticles({
        filter,
      })
    },
    {},
  )

  const getArticleNameById = useCallback(
    (id: number | null | undefined) => {
      if (!id) return ''

      const articles = careArticleByIdQuery?.data?.data?.rows || []
      const articleName = articles.find((article) => article.id === id)?.name
      return articleName || ''
    },
    [careArticleByIdQuery],
  )

  const [isEditCareArticleId, handleEditCareArticleId, handleCloseEditCareArticleId] =
    useShowControl()

  const handleDelete = useCallback(() => {
    onChange?.(null)
  }, [onChange])

  if (disabled && !isDefined(value)) {
    return null
  }

  return (
    <>
      <UIEntityItemConnection
        linkId={value || undefined}
        text="Link to Action Post"
        articleName={getArticleNameById(value)}
        onEdit={!disabled ? handleEditCareArticleId : undefined}
        onDelete={!disabled ? handleDelete : undefined}
      />

      <LinkToActionPostModal
        isOpen={isEditCareArticleId}
        handleClose={handleCloseEditCareArticleId}
        value={value || null}
        onSubmit={(newValue) => {
          onChange?.(newValue)
          handleCloseEditCareArticleId()
        }}
      />
    </>
  )
}
